var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid d-flex flex-column"},[_c('div',{staticClass:"bible-open-head"}),_c('div',{staticClass:"row no-gutters bible-open-body"},[_c('app-bible-tool-profile')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }